import { useAuth } from "../contexts/AuthContext";

interface PreviewBannerProps {
  sectionCount: number;
  subsectionCount: number;
  fieldCount: number;
  note?: string;
}

export function PreviewBanner({ sectionCount, subsectionCount, fieldCount, note }: PreviewBannerProps) {

  const { isAdmin } = useAuth();

  return (
    <div className="bg-yellow-50 border-t border-yellow-200 px-6 py-3">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          {isAdmin && (
            <>
              <div className="w-2 h-2 rounded-full bg-yellow-500" />
              <p className="text-xs text-gray-700">
                {note ?? "Preview Mode - This is how the form will appear to users"}
              </p>
            </>
          )}
        </div>
        <div className="flex items-center gap-4 text-xs text-gray-600">
          <span>{sectionCount} Sections</span>
          <span>•</span>
          <span>{subsectionCount} Subsections</span>
          <span>•</span>
          <span>{fieldCount} Fields</span>
        </div>
      </div>
    </div>
  );
}

export default PreviewBanner;
